import React, { Component, PropTypes } from 'react';
import cx from 'classnames';

const DEFAULT_CLASSES = cx(
  'display-block',
  'color-black',
  'focused-border-shadow',
  'full-width',
  'line-height-1',
  'mg-none',
  'pd-top-sm',
  'pd-bottom-sm',
  'pd-right-md',
  'pd-left-md',
  'resize-none'
);

export default class FormControl extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired
  };

  state = { focused: false };

  getBorderClass() {
    const { required, value } = this.props;
    const { focused } = this.state;
    let color;

    if (focused) {
      if (required && !value) {
        color = 'color-danger';
      } else {
        color = 'color-primary';
      }
    } else {
      color = 'color-light-gray';
    }

    return `border-${color} border-width-1px border-style-solid outline-none`;
  }

  getClasses({ className, disabled, required, value }) {
    const { focused } = this.state;

    const disabledState = disabled;

    return cx(
      DEFAULT_CLASSES,
      this.getBorderClass(),
      { 'is-focused': focused },
      {
        'bg-color-lightest-gray-lighten': disabledState,
        'bg-color-white': !disabledState
      },
      { required: required && !value },
      className
    );
  }

  handleBlur = (event) => {
    const { props } = this.getInput();
    if (props.onBlur) {
      props.onBlur(event);
    }
    this.setState({ focused: false });
  };

  handleFocus = (event) => {
    const { props } = this.getInput();
    if (props.onFocus) {
      props.onFocus(event);
    }
    this.setState({ focused: true });
  };

  getInput() {
    return React.Children.only(this.props.children);
  }

  render() {
    const input = this.getInput();
    const { props: { style, className, disabled, required, value } = {} } = input;

    return React.cloneElement(
      input,
      {
        className: this.getClasses({ className, disabled, required, value }),
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        style: { borderRadius: 4, height: 38, ...style }
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/inputs/FormControl.jsx